import styled from 'styled-components';

import dotsImage from '~/assets/images/dots.svg';

const StyledBgDots = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 92.59vh;
	height: 92.59vh;
	background-image: url(${dotsImage});
	background-position: -1000px -1000px;
	background-size: 2000px 2000px;
`;

const StyledBgShadowContainer = styled.div`
	opacity: 0.8;
`;

const StyledBgShadow = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 500px;
`;

const StyledBgShadow1 = styled(StyledBgShadow)`
	background: linear-gradient(180deg, rgba(17, 19, 20, 0) 0%, #111314 32.29%);
	opacity: 0.25;
`;

const StyledBgShadow2 = styled(StyledBgShadow)`
	background: linear-gradient(180deg, rgba(16, 19, 24, 0) 0%, #101318 32.29%);
	opacity: 0.25;
`;

const StyledBgShadow3 = styled(StyledBgShadow)`
	background: linear-gradient(180deg, rgba(16, 19, 24, 0) 0%, #101318 100%);
`;

export {
	StyledBgDots,
	StyledBgShadow1,
	StyledBgShadow2,
	StyledBgShadow3,
	StyledBgShadowContainer,
};
